@let module = this.module();

@if (module) {
  <div class="flex h-full gap-6">
    <div class="border-grey-3 flex flex-1 flex-col rounded-lg border bg-white">
      <div class="border-b-grey-3 p-sm flex justify-between border-b">
        <div>
          <p class="paragraph-large-semibold">Séquences du Module</p>
          <p class="paragraph-small-medium text-grey-8">{{ module.nom }}</p>
        </div>
        <div class="flex items-center gap-1">
          <button
            (click)="addNewSequence()"
            aria-label="Ajouter une nouvelle séquence"
            hlmTooltipTrigger="Ajouter une nouvelle séquence"
            hlmBtn
            variant="ghost"
            size="icon"
          >
            <ng-icon name="lucidePlus" />
          </button>
          <button [hlmDropdownMenuTrigger]="menu" hlmBtn variant="ghost" size="icon" align="center">
            <ng-icon name="lucideEllipsisVertical" />
          </button>
          <ng-template #menu>
            <hlm-dropdown-menu class="w-max">
              <hlm-dropdown-menu-group>
                <button (triggered)="vueCompacte.set(!vueCompacte())" hlmDropdownMenuItem>
                  <ng-icon hlm size="sm" name="lucideListCollapse" />
                  Vue compacte des séquences
                </button>
                <button hlmDropdownMenuItem>
                  <ng-icon hlm size="sm" name="lucideSave" />
                  Publier la scénarisation
                </button>
              </hlm-dropdown-menu-group>
            </hlm-dropdown-menu>
          </ng-template>
        </div>
      </div>

      <div class="relative flex flex-col gap-4 overflow-y-auto p-6">
        @if (!sequences().length) {
          <div class="my-xxl">
            <app-empty-state [title]="'Aucune séquence créée dans le ' + module.nom">
              <div class="gap-lg grid">
                <span class="text-content-secondary paragraph-medium-medium text-center"
                  >Ajoutez une nouvelle séquence et associez-lui des objectifs. Vous pourrez créer des activités liées à
                  la séquence par la suite.</span
                >
                <button class="mx-auto w-fit" (click)="addNewSequence()" hlmBtn variant="secondary">
                  <ng-icon name="lucidePlus" />
                  Ajouter une nouvelle séquence
                </button>
              </div>
            </app-empty-state>
          </div>
        } @else {
          <app-ordered-list
            [selectedItem]="selectedSequence()"
            [items]="sequences()"
            [actions]="actions"
            (selectedItemChange)="onSelectionChange($event)"
            (itemReordered)="onOrderChange($event)"
            selectable
            orderField="indice"
          >
            <ng-template #itemTemplate let-sequence let-isSelected="isSelected">
              <app-sequence-card
                [sequence]="sequence"
                [isSelected]="isSelected"
                [isExpanded]="!vueCompacte()"
                [class]="{ 'opacity-50': sequence.etat === etatSequence.DESACTIVEE }"
              >
                <button
                  (click)="deleteSequence(sequence)"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                  type="button"
                  aria-label="Supprimer {{ sequence.nom }}"
                  hlmTooltipTrigger="Supprimer"
                >
                  <ng-icon name="lucideTrash" />
                </button>
              </app-sequence-card>
            </ng-template>

            <ng-template #newItemTemplate>
              <app-nouvelle-sequence-card></app-nouvelle-sequence-card>
            </ng-template>
          </app-ordered-list>
        }
      </div>
    </div>
    @if (selectedSequence()) {
      <div class="border-grey-3 h-full w-2/3 rounded-lg border bg-white">
        <app-sequence-form
          [cartographie]="cartographie()"
          [referentiel]="referentiel()"
          [sequence]="selectedSequence()!"
          [module]="module"
        />
      </div>
    }
  </div>
}
